module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/mario-cordova-5a9f80c54c366a83d6bcc8c2c7227ab3.png";